// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.health-page__json {
  margin: 0;
  padding: 1.25rem 1.35rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface);
  color: var(--color-text);
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
    'Courier New', monospace;
  font-size: 0.88rem;
  line-height: 1.55;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
}

.health-page__json--error {
  border-color: color-mix(in srgb, var(--color-danger, #c0392b) 45%, var(--color-border));
}

.health-page code {
  font-family: inherit;
  font-size: 0.9em;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Health.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,wBAAwB;EACxB,qCAAqC;EACrC,4BAA4B;EAC5B,gCAAgC;EAChC,wBAAwB;EACxB;4BAC0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB","sourcesContent":[".health-page__json {\n  margin: 0;\n  padding: 1.25rem 1.35rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface);\n  color: var(--color-text);\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',\n    'Courier New', monospace;\n  font-size: 0.88rem;\n  line-height: 1.55;\n  overflow: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.health-page__json--error {\n  border-color: color-mix(in srgb, var(--color-danger, #c0392b) 45%, var(--color-border));\n}\n\n.health-page code {\n  font-family: inherit;\n  font-size: 0.9em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
